import Cookie from "js-cookie";

const Header = {
  init() {
    Header.events();
  },

  /**
   * Events
   */
  events() {
    Header.scroll();
    $(window).scroll(function () {
      Header.scroll();
    });

    // Toggle mobile menu.
    $(".toggle-header-menu").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      btnEl.toggleClass("active");

      $(".header").toggleClass("header--mobile-open");
      $("html").toggleClass("no-scroll");
    });

    // Acessibility options.
    $(".a11y__cont").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      const a11y = btnEl.data("cont");

      Cookie.set("a11y", a11y);

      $("html").removeClass("a11y a11y-1 a11y-2 a11y-3");
      if ("default" !== a11y) {
        $("html").addClass("a11y a11y-" + a11y);
      }
    });

    // Accessibility option - font size change.
    $(".a11y__fs").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      const fs = btnEl.data("fs");

      Cookie.set("fs", fs);

      $("html").removeClass("fs-15 fs-2");
      $(".a11y__fs").removeClass("active");

      btnEl.addClass("active");

      if ("default" !== fs) {
        $("html").addClass("fs-" + fs);
      }
    });

    // Submenu toggle mobile.
    $(".menu-item-has-children").on("click", (e) => {
      if (!$(".fs-2").length && $(window).innerWidth() > 1200) {
        return;
      }

      if ($(".fs-2").length && $(window).innerWidth() > 1920) {
        return;
      }

      const itemEl = $(e.currentTarget);

      if (itemEl.hasClass("open")) {
        return;
      }

      e.preventDefault();

      itemEl
        .siblings()
        .removeClass("open")
        .find(".sub-menu")
        .slideUp(200)
        .removeClass("open");

      itemEl
        .addClass("open")
        .find(".sub-menu")
        .slideToggle(200)
        .addClass("open");
    });

    // Main menu hover
    const mainMenuEl = $(".header-main__menu-list > .menu-item");
    mainMenuEl
      .mouseenter((e) => {
        const menuItemEl = $(e.currentTarget);
        menuItemEl.siblings().addClass("menu-item-hover");
      })
      .mouseleave(() => {
        mainMenuEl.removeClass("menu-item-hover");
      });

    const mainMenuSubEl = $(
      ".header-main__menu-list > .menu-item .sub-menu > .menu-item"
    );
    mainMenuSubEl
      .mouseenter((e) => {
        const menuItemEl = $(e.currentTarget);
        menuItemEl.siblings().addClass("menu-item-hover");
      })
      .mouseleave(() => {
        mainMenuSubEl.removeClass("menu-item-hover");
      });
  },

  /**
   * Add class on scroll
   */
  scroll() {
    const st = $(window).scrollTop();
    if (st > 110) {
      $(".header").addClass("header--scrolled");
    } else {
      $(".header").removeClass("header--scrolled");
    }
  },
};

export default Header;
